// extracted by mini-css-extract-plugin
module.exports = {"container":"ReportPdfTitle_container__1dwpB","text":"ReportPdfTitle_text__1vDyz"};